function initInfoTabs() {
    document.querySelectorAll('.info_tabs').forEach(function(wrapper) {
        const buttons = wrapper.querySelectorAll('.info_tabs_nav_btn-js');

        buttons.forEach(function(btn) {
            btn.addEventListener('click', function() {
                const target = btn.dataset.target;

                buttons.forEach(function(b) { b.classList.remove('active'); });
                btn.classList.add('active');

                wrapper.querySelectorAll('.info_tabs_panel-js').forEach(function(panel) {
                    panel.classList.toggle('active', panel.id === target);
                });
            });
        });
    });
};

document.addEventListener('DOMContentLoaded', function() {
    initInfoTabs();
});
